import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_BLOQUES_PEDAGOGICOS = 'ALL_BLOQUES_PEDAGOGICOS';
export const ACTIVO_BLOQUES_PEDAGOGICOS = 'ACTIVO_BLOQUES_PEDAGOGICOS';
export const LOADING_ALL_BLOQUES_PEDAGOGICOS =
  'LOADING_ALL_BLOQUES_PEDAGOGICOS';
export const PARAMS_BLOQUES_PEDAGOGICOS = 'PARAMS_BLOQUES_PEDAGOGICOS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const bloquesPedagogicosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_BLOQUES_PEDAGOGICOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_BLOQUES_PEDAGOGICOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_BLOQUES_PEDAGOGICOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_BLOQUES_PEDAGOGICOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
